export default angular.module("mars.vet.dnareports.controllers.multidrugsensitivity",[]).controller('MultidrugSensitivityController',

    function($rootScope, $scope, $window,
            EntryService, EntryIDService, NavigationService, TranslationService, ImageService, UtilityService,
            reportdata) {
        'ngInject';
        let resultString = reportdata.resultString;
        let sampleDetails = reportdata.sampleDetails;

        $scope.getVersionFeature = UtilityService.getVersionFeature('MDR1');
        if ($scope.getVersionFeature) {
            var reportType = 'online';
            $scope.onloadFun = function() {
                reportType = 'pdf';
            }

            EntryService.getEntry(EntryIDService.getEntryID('Multidrug Sensitivity')).then(function(response) {
                var fields = response.fields;
                if (reportType != 'pdf') {
                    $rootScope.pageTitle = fields.title;
                }
                $scope.title = fields.title;
                $scope.descriptionTitle = fields.description.title;
                $scope.description = fields.description.description;
                $scope.breedsAffected = fields.breedsAffected;
                $scope.drugsAffected = fields.drugsAffected;
                $scope.testOrigin = fields.testOrigin;
                $scope.testOriginDesc = $scope.testOrigin.description.replaceAll('[LINKREPLACE]', "<a onclick='instagram_click(this)' >Washington State University</a>");
                var mdrOutcome;
                var copies;
                var mdrStatus;
                var disorderSnps = resultString.disorderSnps;

                ImageService.getImageUrl("M2jxxG0NKmumcEkciqmg0").then(function(response) {
                    $scope.wsuLogo = response.data.fields.file.url;
                });
                angular.forEach(disorderSnps, function(result, key) {
                    if (disorderSnps !== undefined && disorderSnps.length > 0 && result['snp_name'].indexOf("MDR1") != -1) {
                        mdrOutcome = result['outcome'];
                        copies = result['copies'];
                    }
                });
                if (mdrOutcome == 'negative' && copies == '0') {
                    mdrStatus = TranslationService.getTranslation('Normal/Normal');
                } else if (mdrOutcome == 'positive' && copies == '1') {
                    mdrStatus = TranslationService.getTranslation('Mutant/Normal');
                } else if (mdrOutcome == 'positive' && copies == '2') {
                    mdrStatus = TranslationService.getTranslation('Mutant/Mutant');
                } else if (mdrOutcome == 'fail' && copies == -1) {
                    mdrStatus = TranslationService.getTranslation('Failed');
                }

                $scope.outcome = mdrStatus;
                var resultSet = response.fields.testResultsAnalysis[mdrStatus]
                $scope.resultBoxLine1 = resultSet['Line1'].replaceAll("[DOG NAME]", sampleDetails.petDetails.petName);
                $scope.resultBoxLine2 = resultSet['Line2'];
                $scope.resultBoxLine3 = resultSet['Line3'].replaceAll("[DOG NAME]", sampleDetails.petDetails.petName);
                $scope.resultAnalysis = resultSet['Test Results Analysis'];

                NavigationService.setNavigationUrls();
                $window.ga('send', 'pageview', {
                    'page': $rootScope.pageTitle
                });
            }, function(error) {
                // promise rejected, could log the error with:
                // console.log('error', error);
            });
        }
}).name;



// WEBPACK FOOTER //
// ./client/apps/dnareport/controllers/multidrugsensitivity.controller.js